export const actionTypes = {
  CHANGE_THEME: 'CHANGE_THEME',
  SET_BRANDING: 'SET_BRANDING',
  RESET_BRANDING: 'RESET_BRANDING',
};

export const changeColor = (colorSet) => ({
  type: actionTypes.CHANGE_THEME,
  colorSet,
});

// Apply a full tenant branding object (colorSet + logo + brandName + ...).
export const setBranding = (branding) => ({
  type: actionTypes.SET_BRANDING,
  branding,
});

// Revert to the platform default branding (used on logout).
export const resetBranding = () => ({
  type: actionTypes.RESET_BRANDING,
});
